import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import persistStore from "redux-persist/es/persistStore"
import PersistedReducer from "./RootReducer"

export const resetAction = () => ({ type: 'RESET' as const })

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false
})

export const store = configureStore({
  reducer: PersistedReducer,
  middleware: customizedMiddleware

})

export const persistor = persistStore(store)


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch